"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.constantRoutes = exports.asyncRoutes = void 0;
exports.resetRouter = resetRouter;
var _typeof2 = _interopRequireDefault(require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/typeof.js"));
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.weak-map");
require("core-js/modules/es6.function.name");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _vue = _interopRequireDefault(require("vue"));
var _vueRouter = _interopRequireDefault(require("vue-router"));
var _layout = _interopRequireDefault(require("@/layout"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != (0, _typeof2.default)(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
_vue.default.use(_vueRouter.default);

/* Layout */

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
 roles: ['admin','editor']    control the page roles (you can set multiple roles)
 title: 'title'               the name show in sidebar and breadcrumb (recommend set)
 icon: 'svg-name'             the icon show in the sidebar
 breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
 activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
 }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
var constantRoutes = exports.constantRoutes = [{
  path: "/",
  component: _layout.default,
  redirect: "/home",
  hidden: true,
  children: [{
    path: "index",
    name: "shop",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/shop/index"));
      });
    },
    meta: {
      title: "商户管理",
      roles: ["terminal", "partner", "agent", "director", "salesman"]
    }
  }, {
    path: "detail/:id(\\d+)",
    name: "shopDetail1",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/shop/detail"));
      });
    },
    meta: {
      title: "商户详情",
      roles: ["terminal", "partner", "agent", "director", "salesman", "merchants"]
    }
  }, {
    path: "create",
    name: "shopCreate",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/shop/edit"));
      });
    },
    meta: {
      title: "添加商户",
      roles: ["terminal", "partner", "agent", "director", "salesman"]
    }
  }, {
    path: "edit/:id(\\d+)",
    name: "shopEdit",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/shop/edit"));
      });
    },
    meta: {
      title: "编辑商户",
      roles: ["terminal", "partner", "agent", "director", "salesman", "merchants"]
    }
  }]
}, {
  path: "/login/:gid?",
  component: function component() {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require("@/views/login/index"));
    });
  },
  hidden: true
}, {
  path: "/regist",
  component: function component() {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require("@/views/login/regist"));
    });
  },
  hidden: true
}, {
  path: "/404",
  component: function component() {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require("@/views/404"));
    });
  },
  hidden: true
}];

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 * ['terminal','partner','agent','director','salesman','merchants'] ['总站','合伙人','代理商','主管','业务员','商家']
 */
var asyncRoutes = exports.asyncRoutes = [{
  path: "/home",
  name: "home",
  component: _layout.default,
  meta: {
    roles: ["terminal", "partner", "agent", "director", "salesman", "merchants"]
  },
  children: [{
    path: "/home",
    name: "homeIndex",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/home/home"));
      });
    },
    meta: {
      title: "主页",
      icon: "home"
    }
  }, {
    path: "income",
    name: "income",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/home/income"));
      });
    },
    meta: {
      title: "收益明细"
    },
    hidden: true
  }, {
    path: "operateData",
    name: "operateData",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/home/operateData"));
      });
    },
    meta: {
      title: "运营数据"
    },
    hidden: true
  }, {
    path: "article",
    name: "article",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/home/article"));
      });
    },
    meta: {
      title: "最新公告"
    },
    hidden: true
  }, {
    path: "updateRecord",
    name: "updateRecord",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/home/updateRecord"));
      });
    },
    meta: {
      title: "更新公告"
    },
    hidden: true
  }, {
    path: "feedbackEdit",
    name: "feedbackEdit",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/feedback/edit"));
      });
    },
    meta: {
      title: "提交工单"
    },
    hidden: true
  }, {
    path: "feedback",
    name: "feedback",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/feedback/feedback"));
      });
    },
    meta: {
      title: "工单记录"
    },
    hidden: true
  }, {
    path: "dayMoney",
    name: "dayMoney",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/home/dayMoney"));
      });
    },
    meta: {
      title: "日金额统计"
    },
    hidden: true
  }, {
    path: "dayDeposit",
    name: "dayDeposit",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/home/dayDeposit"));
      });
    },
    meta: {
      title: "日押金统计"
    },
    hidden: true
  }, {
    path: "agentDeposit",
    name: "agentDeposit",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/home/deposit"));
      });
    },
    meta: {
      title: "代理用户押金"
    },
    hidden: true
  }]
}, {
  path: "/order",
  component: _layout.default,
  redirect: "/order/morder",
  name: "order",
  meta: {
    title: "订单管理",
    icon: "order",
    roles: ["terminal", "partner", "agent", "director", "salesman", "merchants"]
  },
  children: [{
    path: "order",
    name: "orderIndex",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/order/order"));
      });
    },
    meta: {
      title: "全部订单"
    },
    props: {
      user_type: 2
    },
    hidden: true
  }, {
    path: "morder",
    name: "morder",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/order/order"));
      });
    },
    meta: {
      title: "我的订单"
    },
    props: {
      user_type: 0
    },
    hidden: true
  }, {
    path: "meOrder",
    name: "meOrder",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/order/order"));
      });
    },
    meta: {
      title: "我的订单",
      roles: ["partner", "agent", "director", "salesman", "merchants"]
    },
    props: {
      user_type: 0
    }
  }, {
    path: "subOrder",
    name: "subOrder1",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/order/order"));
      });
    },
    meta: {
      title: "下级订单",
      roles: ["partner", "agent", "director"]
    },
    props: {
      user_type: 1
    }
  }, {
    path: "hOrder",
    name: "hOrder1",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/order/historyorder"));
      });
    },
    meta: {
      title: "历史订单",
      roles: ["partner", "agent", "director"]
    },
    props: {
      user_type: 2
    }
  }, {
    path: "subOrder",
    name: "terminalSubOrder",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/order/order"));
      });
    },
    meta: {
      title: "订单管理",
      roles: ["terminal"]
    },
    props: {
      user_type: 1
    }
  }, {
    path: "detail",
    name: "detail",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/order/detail"));
      });
    },
    meta: {
      title: "订单详情"
    },
    hidden: true
  },
  // {
  //   path: 'accredit',
  //   name: 'accredit',
  //   component: () => import('@/views/order/accredit'),
  //   meta: {
  //     title: '授权订单',
  //     roles: ['terminal', 'partner', 'agent']
  //   }
  // },
  {
    path: "editAccredit",
    name: "editAccredit",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/order/editAccredit"));
      });
    },
    meta: {
      title: "添加授权订单",
      roles: ["partner"]
    },
    hidden: true
  }, {
    path: "scanCode",
    name: "scanCode",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/order/scanCode"));
      });
    },
    meta: {
      title: "扫码记录"
    },
    hidden: true
  }, {
    path: "scanStat",
    name: "scanStat",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/order/scanStat"));
      });
    },
    meta: {
      title: "扫码统计"
    },
    hidden: true
  }]
}, {
  path: "/equipment",
  name: "equipment",
  component: _layout.default,
  redirect: "/equipment/index",
  meta: {
    title: "设备管理",
    icon: "equipment",
    roles: ["terminal", "partner", "agent", "director", "salesman", "merchants"]
  },
  children: [{
    path: "shopEquip",
    name: "shopEquip",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/equipment/shopEquip"));
      });
    },
    meta: {
      title: "我的设备",
      roles: ["merchants"]
    }
  }, {
    path: "index",
    name: "equipmentIndex",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/equipment/index"));
      });
    },
    meta: {
      title: "我的设备",
      roles: ["partner", "agent", "director", "salesman"]
    },
    // props: {
    //   user_type: 0
    // },
    props: function props(route) {
      return {
        user_type: route.query.user_type || 0
      };
    }
  }, {
    path: "subEquipment",
    name: "subEquipment1",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/equipment/index"));
      });
    },
    meta: {
      title: "下级设备",
      roles: ["partner", "agent", "director", "salesman"]
    },
    props: {
      user_type: 1
    }
  }, {
    path: "subEquipment",
    name: "terminalSubEquipment",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/equipment/index"));
      });
    },
    meta: {
      title: "设备管理",
      roles: ["terminal"]
    },
    props: {
      user_type: 1
    }
  }, {
    path: "powerBankRecord/:id(\\d+)",
    name: "powerBankRecord",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/equipment/powerBankRecord"));
      });
    },
    meta: {
      title: "流通记录",
      activeMenu: "/equipment/powerBank"
    },
    hidden: true
  }, {
    path: "popup/:goods_sn",
    name: "equipPopup",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/equipment/popup"));
      });
    },
    meta: {
      title: "设备弹出",
      activeMenu: "/equipment/index"
    },
    hidden: true
  }, {
    path: "popupRecord/:goods_sn",
    name: "popupRecord",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/equipment/popupRecord"));
      });
    },
    meta: {
      title: "设备弹出记录",
      activeMenu: "/equipment/index"
    },
    hidden: true
  }, {
    path: "signal",
    name: "signal",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/equipment/signal"));
      });
    },
    meta: {
      title: "设备信号曲线图",
      activeMenu: "/equipment/index"
    },
    hidden: true
  }, {
    path: "adver/:id(\\d+)",
    name: "shopAdver",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/shop/adver"));
      });
    },
    meta: {
      title: "跳转广告",
      activeMenu: "/shop/index"
    },
    hidden: true
  }]
}, {
  path: "/shop",
  component: _layout.default,
  redirect: "/shop/index",
  name: "shopIndex",
  meta: {
    title: "商户管理",
    icon: "shop",
    roles: ["terminal", "partner", "agent", "director", "salesman"]
  },
  children: [{
    path: "allShop",
    name: "allShop",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/shop/index"));
      });
    },
    meta: {
      keepAlive: true,
      title: "全部商户"
    },
    props: {
      user_type: 2
    },
    hidden: true
  }, {
    path: "index",
    name: "shop",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/shop/index"));
      });
    },
    meta: {
      keepAlive: true,
      title: "我的商户",
      roles: ["partner", "agent", "director", "salesman"]
    },
    props: {
      user_type: 0
    }
  }, {
    path: "subShop",
    name: "subShop1",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/shop/index"));
      });
    },
    meta: {
      keepAlive: true,
      title: "下级商户",
      roles: ["partner", "agent", "director", "salesman"]
    },
    props: {
      user_type: 1
    }
  }, {
    path: "subShop",
    name: "terminalSubShop",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/shop/index"));
      });
    },
    meta: {
      keepAlive: true,
      title: "商户管理",
      roles: ["terminal"]
    },
    props: {
      user_type: 1
    }
  }, {
    path: "detail/:id(\\d+)",
    name: "shopDetail",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/shop/detail"));
      });
    },
    meta: {
      title: "商户详情",
      activeMenu: "/shop/index"
    },
    hidden: true
  }, {
    path: "create",
    name: "shopCreate",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/shop/edit"));
      });
    },
    meta: {
      title: "添加商户",
      roles: ["partner", "agent", "director", "salesman"]
    }
  }, {
    path: "edit/:id(\\d+)",
    name: "shopEdit",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/shop/edit"));
      });
    },
    meta: {
      title: "编辑商户",
      activeMenu: "/shop/index"
    },
    hidden: true
  }, {
    path: "setvip",
    name: "setvip",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/shop/setvip"));
      });
    },
    meta: {
      title: "添加会员",
      activeMenu: "/shop/index"
    },
    hidden: true
  }, {
    path: "billing/:id(\\d+)",
    name: "billing",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/shop/billing"));
      });
    },
    meta: {
      title: "计费设置",
      activeMenu: "/shop/index"
    },
    hidden: true
  }, {
    path: "steal/:id(\\d+)",
    name: "steal",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/shop/steal"));
      });
    },
    meta: {
      title: "掉单设置",
      activeMenu: "/shop/index"
    },
    hidden: true
  }, {
    path: "withdraw",
    name: "shopWithdraw",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/shop/withdraw"));
      });
    },
    meta: {
      title: "商户提现信息设置",
      activeMenu: "/shop/index"
    },
    hidden: true
  }, {
    path: "public/:id(\\d+)",
    name: "shopPublic",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/shop/public"));
      });
    },
    meta: {
      title: "公众号设置",
      activeMenu: "/shop/index"
    },
    hidden: true
  }, {
    path: "replySet",
    name: "replySet",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/shop/replySet"));
      });
    },
    meta: {
      title: "关注回复设置"
    },
    hidden: true
  }]
}, {
  path: "/merchant-electricity",
  component: _layout.default,
  redirect: "/merchant-electricity/overview",
  name: "MerchantElectricity",
  meta: {
    title: "商户电费管理",
    icon: "zijing",
    roles: ["partner", "agent", "director", "salesman"]
  },
  children: [{
    path: "overview",
    name: "MerchantElectricityOverview",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/merchantElectricity/overview"));
      });
    },
    meta: {
      title: "电费概览",
      roles: ["partner", "agent", "director", "salesman"]
    }
  }, {
    path: "monthly-bill",
    name: "MerchantElectricityMonthlyBill",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/merchantElectricity/monthlyBill"));
      });
    },
    meta: {
      title: "月度账单",
      roles: ["partner", "agent", "director", "salesman"]
    }
  }, {
    path: "daily-usage",
    name: "MerchantElectricityDailyUsage",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/merchantElectricity/dailyUsage"));
      });
    },
    meta: {
      title: "用电明细",
      roles: ["partner", "agent", "director", "salesman"]
    }
  }, {
    path: "withdraw-records",
    name: "MerchantElectricityWithdrawRecords",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/merchantElectricity/withdrawRecords"));
      });
    },
    meta: {
      title: "打款记录",
      roles: ["partner", "agent", "director", "salesman"]
    }
  }]
}, {
  path: "/myshop",
  component: _layout.default,
  redirect: "/shop/myShop",
  meta: {
    title: "我的商户",
    icon: "shop",
    roles: ["merchants"]
  },
  children: [{
    path: "myShop",
    name: "myShop",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/shop/myShop"));
      });
    },
    meta: {
      title: "我的商户"
    }
  }]
}, {
  path: "/userManage",
  component: _layout.default,
  redirect: "/userManage/userList",
  name: "userManage",
  meta: {
    title: "用户管理",
    icon: "userList",
    roles: ["terminal", "partner", "agent", "director", "salesman"]
  },
  children: [{
    path: "userList",
    name: "userList",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/user/userList"));
      });
    },
    meta: {
      title: "用户列表",
      roles: ["terminal", "partner", "agent", "director", "salesman", "merchants"]
    }
  }, {
    path: "payComplaints",
    name: "payComplaints",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/user/payComplaints"));
      });
    },
    meta: {
      title: "用户投诉",
      roles: ["partner"],
      keepAlive: true
    }
  }, {
    path: "PCDetail",
    name: "PCDetail",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/user/PCDetail"));
      });
    },
    meta: {
      title: "用户投诉详情",
      roles: ["partner"]
    },
    hidden: true
  }, {
    path: "userFeedback",
    name: "userFeedback",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/feedback/userFeedback"));
      });
    },
    meta: {
      title: "用户反馈",
      roles: ["partner"]
    }
  }, {
    path: "portrait",
    name: "portrait",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/user/portrait"));
      });
    },
    meta: {
      title: "用户画像",
      roles: ["partner"]
    }
  }, {
    path: "user_order",
    name: "user_order",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/order/order"));
      });
    },
    meta: {
      title: "用户订单"
    },
    props: {
      user_type: 2
    },
    hidden: true
  }]
}, {
  path: "/qrcode",
  component: _layout.default,
  redirect: "/qrcode/index",
  name: "qrcodeIndex",
  meta: {
    title: "二维码管理",
    icon: "qrcode",
    roles: ["terminal"]
  },
  children: [{
    path: "index",
    name: "qrcode",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/qrcode/index"));
      });
    },
    meta: {
      keepAlive: true,
      title: "二维码管理"
    }
  }, {
    path: "edit",
    name: "qrcodeEdit",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/qrcode/edit"));
      });
    },
    meta: {
      title: "编辑二维码"
    },
    hidden: true
  }, {
    path: "create",
    name: "qrcodecreate",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/qrcode/create"));
      });
    },
    meta: {
      title: "生成二维码"
    },
    hidden: true
  }]
}, {
  path: "/partner",
  component: _layout.default,
  redirect: "/partner/index",
  name: "partnerIndex",
  meta: {
    title: "品牌管理",
    icon: "agent",
    roles: ["terminal"]
  },
  children: [{
    path: "index",
    name: "agent",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/agent/index"));
      });
    },
    meta: {
      title: "我的品牌",
      keepAlive: true
    },
    props: {
      user_type: 0
    }
  }, {
    path: "subAgent",
    name: "subAgent",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/agent/index"));
      });
    },
    meta: {
      title: "下级代理",
      keepAlive: true
    },
    props: {
      user_type: 1
    }
  }, {
    path: "create",
    name: "agentCreate",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/agent/edit"));
      });
    },
    meta: {
      title: "添加品牌"
    }
  }]
}, {
  path: "/agent",
  component: _layout.default,
  redirect: "/agent/index",
  name: "agentManger",
  meta: {
    title: "代理管理",
    icon: "agent",
    roles: ["terminal", "partner", "agent", "director"]
  },
  children: [{
    path: "index",
    name: "agentIndex",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/agent/index"));
      });
    },
    meta: {
      title: "我的代理",
      roles: ["partner", "agent", "director"],
      keepAlive: true
    },
    props: {
      user_type: 0
    }
  }, {
    path: "subAgent",
    name: "subAgent1",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/agent/index"));
      });
    },
    meta: {
      title: "下级代理",
      roles: ["partner", "agent", "director"],
      keepAlive: true
    },
    props: {
      user_type: 1
    }
  }, {
    path: "create",
    name: "agentCreate1",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/agent/edit"));
      });
    },
    meta: {
      title: "添加代理",
      roles: ["partner", "agent", "director"]
    }
  }, {
    path: "promoterAdmin",
    name: "promoterAdmin",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/admin/promoterIndex"));
      });
    },
    meta: {
      title: "推广员列表",
      roles: ["partner", "agent", "director"]
    }
  }, {
    path: "promoterAgent",
    name: "promoterAgent",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/admin/promoterAgent"));
      });
    },
    meta: {
      title: "推荐官列表",
      roles: ["partner", "agent", "director"]
    }
  }, {
    path: "edit/:id(\\d+)",
    name: "agentEdit",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/agent/edit"));
      });
    },
    meta: {
      title: "编辑代理",
      activeMenu: "/agent/index",
      roles: ["terminal", "partner", "agent", "director"]
    },
    hidden: true
  }, {
    path: "equip",
    name: "agentEquip",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/agent/equip"));
      });
    },
    meta: {
      title: "代理设备",
      activeMenu: "/agent/index",
      roles: ["terminal", "partner", "agent", "director"]
    },
    hidden: true
  }, {
    path: "contract",
    name: "contract",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/agent/contract"));
      });
    },
    meta: {
      title: "合同管理",
      activeMenu: "/agent/contract"
    },
    hidden: true
  }, {
    path: "agentBilling",
    name: "agentBilling",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/agent/billing"));
      });
    },
    meta: {
      title: "合伙人计费方式",
      activeMenu: "/agent/index"
    },
    hidden: true
  }, {
    path: "buyprice",
    name: "buyprice",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/agent/buyprice"));
      });
    },
    meta: {
      title: "采购价",
      activeMenu: "/agent/index"
    },
    hidden: true
  }]
}, {
  path: "/condom",
  component: _layout.default,
  redirect: "/condom/goods",
  meta: {
    title: "商品管理",
    icon: "agent",
    roles: ["partner", "agent", "director", "salesman"]
  },
  children: [{
    path: "goods",
    name: "condomGoods",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/condom/goods"));
      });
    },
    meta: {
      title: "商品管理",
      roles: ["partner"],
      keepAlive: true
    }
  }, {
    path: "billing",
    name: "condomBilling",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/setting/billing"));
      });
    },
    meta: {
      title: "默认设置",
      roles: ["partner"]
    },
    props: {
      cutDevice: 7
    }
  }, {
    path: "goodsEdit",
    name: "condomGoodsEdit",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/condom/goodsEdit"));
      });
    },
    meta: {
      title: "添加商品",
      roles: ["partner"]
    }
  }, {
    path: "shopGoods/:id(\\d+)",
    name: "shopCondomGoods",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/condom/shopGoods"));
      });
    },
    meta: {
      title: "关联商品",
      roles: ["partner", "agent", "director", "salesman"]
    },
    hidden: true
  }]
}, {
  path: "/withdraw",
  component: _layout.default,
  redirect: "/withdraw/reviewe",
  name: "withdrawReviewe",
  meta: {
    title: "资金管理",
    icon: "zijing"
  },
  children: [{
    path: "reviewe",
    name: "reviewe",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/withdraw/reviewe"));
      });
    },
    meta: {
      title: "代理提现",
      roles: ["partner", "agent", "director", "salesman"]
    },
    props: {
      user_type: 1
    }
  }, {
    path: "shopReviewe",
    name: "withdrawReviewe",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/withdraw/reviewe"));
      });
    },
    meta: {
      title: "商户提现",
      roles: ["partner", "agent", "director", "salesman"]
    },
    props: {
      user_type: 2
    }
  }, {
    path: "promoterReviewe",
    name: "promoterReviewe",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/withdraw/promoterReviewe"));
      });
    },
    meta: {
      title: "推广员提现",
      roles: ["partner", "agent", "director", "salesman"]
    },
    props: {
      user_type: 3
    }
  }, {
    path: "promoterAgentReviewe",
    name: "promoterAgentReviewe",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/withdraw/promoterAgentReviewe"));
      });
    },
    meta: {
      title: "推荐官提现",
      roles: ["partner", "agent", "director", "salesman"]
    },
    props: {
      user_type: 3
    }
  }, {
    path: "userReviewe",
    name: "userReviewe",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/withdraw/userReviewe"));
      });
    },
    meta: {
      title: "用户提现",
      roles: ["partner"]
    }
  }, {
    path: "doorfee",
    name: "doorfee",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/withdraw/doorfee"));
      });
    },
    meta: {
      title: "入场费记录",
      roles: ["partner"]
    }
  }, {
    path: "withdraw",
    name: "withdraw",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/withdraw/withdraw"));
      });
    },
    meta: {
      title: "申请提现",
      roles: ["agent", "director", "salesman", "merchants"]
    }
  }, {
    path: "record",
    name: "withdrawRecord",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/withdraw/record"));
      });
    },
    meta: {
      title: "我的提现记录",
      roles: ["agent", "director", "salesman", "merchants"]
    }
  }, {
    path: "recharge",
    name: "recharge",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/withdraw/recharge"));
      });
    },
    meta: {
      title: "充值记录",
      roles: ["partner"]
    }
  }, {
    path: "cashpledge",
    name: "cashpledge",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/withdraw/cashpledge"));
      });
    },
    meta: {
      title: "退押管理",
      roles: ["partner"]
    }
  }, {
    path: "member",
    name: "member",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/withdraw/member"));
      });
    },
    meta: {
      title: "会员开通记录",
      roles: ["partner"]
    }
  }]
}, {
  path: "/entity",
  component: _layout.default,
  redirect: "/entity/card",
  name: "entityCards",
  meta: {
    title: "充值卡",
    icon: "withdraw",
    roles: ["partner"]
  },
  children: [{
    path: "card",
    name: "entityCard",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/entity/card"));
      });
    },
    meta: {
      title: "充值卡"
    }
  }, {
    path: "charge",
    name: "charge",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/entity/charge"));
      });
    },
    meta: {
      title: "充值记录"
    }
  }, {
    path: "chargeMoney",
    name: "chargeMoney",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/entity/chargeMoney"));
      });
    },
    meta: {
      title: "充值设置"
    }
  }]
}, {
  path: "/run",
  component: _layout.default,
  redirect: "/run/customerRecord",
  name: "run",
  meta: {
    title: "运营管理",
    icon: "run"
  },
  children: [{
    path: "logQuery",
    name: "logQuery",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/run/logQuery.vue"));
      });
    },
    meta: {
      title: "日志查询"
    }
  }, {
    path: "customerRecord",
    name: "customerRecord",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/run/customerRecord.vue"));
      });
    },
    meta: {
      title: "客户跟进记录"
    }
  }, {
    path: "shopAlarm",
    name: "shopAlarm",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/run/shopAlarm"));
      });
    },
    meta: {
      title: "商户警报",
      roles: ["terminal", "partner", "agent", "director", "salesman"]
    }
  }, {
    path: "agentAlarm",
    name: "agentAlarm",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/run/agentAlarm"));
      });
    },
    meta: {
      title: "代理警报",
      roles: ["terminal", "partner"]
    }
  }, {
    path: "deviceOrder",
    name: "deviceOrder",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/run/deviceOrder"));
      });
    },
    meta: {
      title: "设备购买记录",
      roles: ["terminal", "partner"]
    }
  }, {
    path: "repair",
    name: "repair",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/equipment/repair"));
      });
    },
    meta: {
      title: "设备报修记录"
    }
  }, {
    path: "powerBank",
    name: "powerBank",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/equipment/powerBank"));
      });
    },
    meta: {
      title: "充电宝管理",
      roles: ["terminal", "partner", "agent", "director", "salesman"]
    }
  }, {
    path: "operating",
    name: "operating",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/equipment/operating"));
      });
    },
    meta: {
      title: "设备运营",
      roles: ["terminal", "partner", "agent", "director", "salesman"]
    }
  }, {
    path: "operationsData",
    name: "operationsData",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/run/operationsData.vue"));
      });
    },
    meta: {
      title: "运营数据"
    }
  }, {
    path: "operationLog",
    name: "operationLog",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/run/operationLog.vue"));
      });
    },
    meta: {
      title: "平台更改日志"
    }
  }, {
    path: "device",
    name: "deviceType",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/setting/device"));
      });
    },
    meta: {
      title: "设备类型",
      roles: ["terminal"]
    }
  }]
}, {
  path: "/adver",
  component: _layout.default,
  redirect: "/adver/weChatBase",
  name: "adverWeChatBase",
  meta: {
    title: "广告管理",
    icon: "ad"
  },
  children: [{
    path: "weChatBase",
    name: "weChatAdBase",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/adver/weChatBase"));
      });
    },
    meta: {
      title: "微信广告",
      roles: ["terminal", "partner"]
    }
  }, {
    path: "weChatList",
    name: "weChatAdList",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/adver/weChatList"));
      });
    },
    meta: {
      title: "广告列表",
      activeMenu: "/adver/weChatBase",
      roles: ["terminal", "partner"]
    },
    hidden: true
  }, {
    path: "weChatData",
    name: "weChatData",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/adver/weChatData"));
      });
    },
    meta: {
      title: "微信广告数据",
      activeMenu: "/adver/weChatBase",
      roles: ["terminal", "partner"]
    },
    hidden: true
  }, {
    path: "position",
    name: "adPosition",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/adver/position"));
      });
    },
    meta: {
      title: "传统广告",
      roles: ["terminal", "partner", "agent", "director", "merchants"]
    }
  }, {
    path: "adAudit",
    name: "adAudit",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/adver/adAudit"));
      });
    },
    meta: {
      title: "广告审核",
      roles: ["partner"]
    }
  }, {
    path: "setPower",
    name: "setPower",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/adver/position"));
      });
    },
    meta: {
      title: "广告位"
    },
    hidden: true
  }, {
    path: "photo",
    name: "adPhoto",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/adver/photo"));
      });
    },
    meta: {
      activeMenu: "/adver/position",
      title: "广告列表"
    },
    hidden: true
  }, {
    path: "edit",
    name: "adEdit",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/adver/edit"));
      });
    },
    meta: {
      activeMenu: "/adver/position",
      title: "添加广告"
    },
    hidden: true
  }, {
    path: "bindEquip",
    name: "bindEquip",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/adver/bindEquip"));
      });
    },
    meta: {
      activeMenu: "/adver/position",
      title: "广告绑定设备"
    },
    hidden: true
  }]
}, {
  path: "/wx",
  component: _layout.default,
  redirect: "/wx/index",
  name: "wxIndex",
  meta: {
    title: "微信小程序",
    icon: "wx",
    roles: ["terminal", "partner"]
  },
  children: [{
    path: "create",
    name: "createXcx",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/wx/edit"));
      });
    },
    meta: {
      title: "绑定小程序",
      roles: ["terminal", "partner"]
    },
    hidden: true
  }, {
    path: "edit/:id(\\d+)",
    name: "editXcx",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/wx/edit"));
      });
    },
    meta: {
      title: "修改小程序",
      roles: ["terminal", "partner"]
    },
    hidden: true
  }, {
    path: "domain",
    name: "domainXcx",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/wx/domain"));
      });
    },
    meta: {
      title: "小程序域名",
      roles: ["terminal", "partner"]
    },
    hidden: true
  }, {
    path: "index",
    name: "wxindexshow",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/wx/index"));
      });
    },
    meta: {
      title: "小程序管理",
      roles: ["terminal"]
    }
  }, {
    path: "paymch",
    name: "paymch",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/wx/paymch"));
      });
    },
    meta: {
      title: "微信支付商户管理",
      roles: ["terminal", "partner"]
    }
  }, {
    path: "paymchcreate",
    name: "paymchcreate",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/wx/paymchedit"));
      });
    },
    meta: {
      title: "绑定微信支付商户",
      roles: ["terminal", "partner"]
    },
    hidden: true
  }, {
    path: "paymchedit/:id(\\d+)",
    name: "paymchedit",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/wx/paymchedit"));
      });
    },
    meta: {
      title: "修改微信支付商户",
      roles: ["terminal", "partner"]
    },
    hidden: true
  }, {
    path: "wxpublic",
    name: "wxpublic",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/wx/wxpublic"));
      });
    },
    meta: {
      title: "公众号管理",
      roles: ["terminal"]
    }
  }, {
    path: "public",
    name: "public",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/wx/public"));
      });
    },
    meta: {
      title: "微信公众号",
      roles: ["terminal"]
    },
    hidden: true
  }, {
    path: "draft",
    name: "wxdraft",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/wx/draft"));
      });
    },
    meta: {
      title: "草稿列表",
      roles: ["terminal"]
    }
  }, {
    path: "temp",
    name: "wxtemp",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/wx/temp"));
      });
    },
    meta: {
      title: "模板列表",
      roles: ["terminal"]
    }
  }, {
    path: "systemConfig",
    name: "systemConfig",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/wx/systemConfig"));
      });
    },
    meta: {
      title: "系统配置",
      roles: ["terminal"]
    }
  }]
}, {
  path: "/ali",
  component: _layout.default,
  redirect: "/ali/index",
  name: "aliIndex",
  meta: {
    title: "支付宝小程序",
    icon: "ali",
    roles: ["terminal", "partner"]
  },
  children: [{
    path: "index",
    name: "aliindexshow",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/ali/index"));
      });
    },
    meta: {
      title: "支付宝小程序",
      roles: ["terminal"]
    }
  }, {
    path: "create",
    name: "createXcx",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/ali/edit"));
      });
    },
    meta: {
      title: "绑定小程序",
      roles: ["terminal", "partner"]
    },
    hidden: true
  }, {
    path: "edit/:id(\\d+)",
    name: "editXcx",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/ali/edit"));
      });
    },
    meta: {
      title: "修改小程序",
      roles: ["terminal", "partner"]
    },
    hidden: true
  }]
}, {
  path: "/user",
  component: _layout.default,
  redirect: "/user/index",
  name: "userIndex",
  meta: {
    title: "我的信息",
    icon: "user"
  },
  children: [{
    path: "index",
    name: "userInfo",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/user/index"));
      });
    },
    meta: {
      title: "资料管理"
    }
  }, {
    path: "lpw",
    name: "loginPw",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/user/loginPw"));
      });
    },
    meta: {
      title: "登录密码"
    }
  }, {
    path: "wpw",
    name: "withdrawPw",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/user/withdrawPw"));
      });
    },
    meta: {
      title: "提现密码",
      roles: ["agent", "director", "salesman", "merchants"]
    }
  }]
}, {
  path: "/setting",
  component: _layout.default,
  redirect: "/setting/index",
  name: "setting",
  meta: {
    title: "系统设置",
    icon: "setting",
    roles: ["partner"]
  },
  children: [{
    path: "index",
    name: "wxSetting",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/wx/index"));
      });
    },
    meta: {
      title: "微信小程序",
      roles: ["partner"]
    }
  }, {
    path: "paymch",
    name: "paymchSetting",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/wx/paymch"));
      });
    },
    meta: {
      title: "微信商户号管理",
      roles: ["partner"]
    }
  }, {
    path: "public",
    name: "publicSetting",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/wx/public"));
      });
    },
    meta: {
      title: "微信公众号",
      roles: ["partner"]
    }
  }, {
    path: "aliIndex",
    name: "alindexSetting",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/ali/index"));
      });
    },
    meta: {
      title: "支付宝小程序",
      roles: ["partner"]
    }
  }, {
    path: "sys",
    name: "sysConfig",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/sys/index"));
      });
    },
    meta: {
      title: "系统自动配置管理",
      roles: ["partner"]
    }
  }, {
    path: "system",
    name: "systemSetting",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/setting/system"));
      });
    },
    meta: {
      title: "系统设置",
      roles: ["partner"]
    }
  }, {
    path: "mytmpl",
    name: "mytmplSetting",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/setting/mytmpl"));
      });
    },
    meta: {
      title: "模板消息",
      roles: ["partner"]
    }
  }, {
    path: "share",
    name: "shareSetting",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/setting/share"));
      });
    },
    meta: {
      title: "分享设置",
      roles: ["partner"]
    }
  }, {
    path: "billing",
    name: "billingSetting",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/setting/billing"));
      });
    },
    meta: {
      title: "默认设置",
      roles: ["partner"]
    }
  }, {
    path: "info",
    name: "infoSetting",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/setting/info"));
      });
    },
    meta: {
      title: "平台信息"
    }
  }, {
    path: "helpSetting",
    name: "helpSetting",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/setting/helpSetting"));
      });
    },
    meta: {
      title: "帮助中心",
      roles: ["partner"]
    }
  }, {
    path: "alink",
    name: "alink",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/setting/link"));
      });
    },
    meta: {
      title: "相关链接",
      roles: ["partner"]
    }
  }]
}, {
  path: "/station",
  component: _layout.default,
  redirect: "/station/renewRecord",
  name: "stationRenewRecord",
  meta: {
    title: "贴牌管理",
    icon: "setting",
    roles: ["terminal"]
  },
  children: [{
    path: "renewRecord",
    name: "renewRecord",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/station/renewRecord"));
      });
    },
    meta: {
      title: "续费记录"
    }
  }, {
    path: "oemMoney",
    name: "oemMoney",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/station/oemMoney"));
      });
    },
    meta: {
      title: "续费设置"
    }
  }]
}, {
  path: "/tutorial",
  component: _layout.default,
  redirect: "/tutorial/tutorial",
  name: "tutorialTutorial",
  meta: {
    title: "公告教程",
    icon: "gonggao",
    roles: ["terminal", "partner", "agent", "director"]
  },
  children: [{
    path: "tutorial",
    name: "tutorial",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/tutorial/list"));
      });
    },
    meta: {
      title: "使用教程"
    },
    props: {
      type: 3,
      title: "教程"
    }
  }, {
    path: "notice",
    name: "notice",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/tutorial/list"));
      });
    },
    meta: {
      title: "最新公告"
    },
    props: {
      type: 1,
      title: "公告"
    }
  }, {
    path: "news",
    name: "news",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/tutorial/list"));
      });
    },
    meta: {
      title: "头条新闻"
    },
    props: {
      type: 2,
      title: "头条"
    }
  }, {
    path: "update",
    name: "tutorialUpdate",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/tutorial/list"));
      });
    },
    meta: {
      title: "更新公告",
      roles: ["terminal"]
    },
    props: {
      type: 4,
      title: "更新公告"
    }
  }, {
    path: "edit",
    name: "tutorialEdit",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/tutorial/edit"));
      });
    },
    meta: {
      activeMenu: "/tutorial/tutorial",
      title: "编辑"
    },
    hidden: true
  }, {
    path: "detail/:id(\\d+)",
    name: "tutorialDetail",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/tutorial/detail"));
      });
    },
    meta: {
      title: "详情"
    },
    hidden: true
  }]
}, {
  path: "/permission",
  component: _layout.default,
  name: "permissionIndex",
  meta: {
    title: "权限管理",
    icon: "gonggao",
    roles: ["terminal", "partner"]
  },
  children: [{
    path: "admin",
    name: "manageUser",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/admin/index"));
      });
    },
    meta: {
      title: "管理员列表"
    }
  }, {
    path: "index",
    name: "permissionList",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/permission/index"));
      });
    },
    meta: {
      title: "权限树列"
    }
  }, {
    path: "add",
    name: "permissionAdd",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/permission/add"));
      });
    },
    meta: {
      title: "添加权限"
    }
  }
  // ,
  // {
  //   path: 'role',
  //   name: 'RolePermission',
  //   component: () => import('@/views/permission/role'),
  //   meta: {
  //     title: '角色管理'
  //   }
  // }
  ]
}, {
  path: "/mall",
  name: "mallIndex",
  meta: {
    title: "在线商城",
    icon: "mall"
  },
  children: [{
    path: "index",
    name: "mall",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/mall/index"));
      });
    },
    meta: {
      title: "在线商城"
    }
  }]
}, {
  path: "/signup",
  component: _layout.default,
  redirect: "/signup/index",
  name: "signupActivity",
  meta: {
    title: "报名活动",
    icon: "signup",
    roles: ["partner"]
  },
  children: [{
    path: "index",
    name: "signupAct",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/signup/index"));
      });
    },
    meta: {
      title: "活动列表",
      roles: ["partner"]
    }
  }, {
    path: "edit",
    name: "signupEdit",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/signup/edit"));
      });
    },
    meta: {
      title: "添加活动"
    }
  }, {
    path: "signIn",
    name: "signIn",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/signup/signIn"));
      });
    },
    meta: {
      title: "报名记录"
    },
    hidden: true
  }]
},
// 运营数据模块
{
  path: "/run",
  component: _layout.default,
  redirect: "/run/logQuery",
  name: "run",
  meta: {
    title: "运营数据",
    icon: "run",
    roles: ["terminal", "partner", "agent", "director", "salesman"]
  },
  children: [{
    path: "logQuery",
    name: "logQuery",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/run/logQuery"));
      });
    },
    meta: {
      title: "日志查询"
    },
    hidden: true
  }, {
    path: "operationLog",
    name: "operationLog",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/run/operationLog"));
      });
    },
    meta: {
      title: "操作日志"
    },
    hidden: true
  }, {
    path: "customerRecord",
    name: "customerRecord",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/run/customerRecord"));
      });
    },
    meta: {
      title: "客户跟进记录"
    },
    hidden: true
  }, {
    path: "deviceOrder",
    name: "deviceOrder",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/run/deviceOrder"));
      });
    },
    meta: {
      title: "设备订单"
    },
    hidden: true
  }, {
    path: "operationsData",
    name: "operationsData",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/run/operationsData"));
      });
    },
    meta: {
      title: "运营数据"
    },
    hidden: true
  }, {
    path: "agentAlarm",
    name: "agentAlarm",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/run/agentAlarm"));
      });
    },
    meta: {
      title: "代理商告警"
    },
    hidden: true
  }, {
    path: "shopAlarm",
    name: "shopAlarm",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/run/shopAlarm"));
      });
    },
    meta: {
      title: "商户告警"
    },
    hidden: true
  }]
},
// 404 page must be placed at the end !!!
{
  path: "*",
  redirect: "/404",
  hidden: true
}, {
  path: "/dataV",
  name: "dataV",
  component: function component() {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require("@/views/datav/index"));
    });
  },
  meta: {
    title: "大屏统计",
    roles: ["terminal", "partner"],
    icon: "run"
  }
}];
var createRouter = function createRouter() {
  return new _vueRouter.default({
    mode: "history",
    // require service support
    routes: constantRoutes,
    scrollBehavior: function scrollBehavior(to, from, savePosition) {
      if (savePosition) {
        return savePosition;
      } else {
        return {
          x: 0,
          y: 0
        };
      }
    }
  });
};
var router = createRouter();
router.beforeEach(/*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee(to, from, next) {
    var routeData;
    return regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!(from.name && from.name != "dataV" && to.name == "dataV")) {
            _context.next = 1;
            break;
          }
          routeData = router.resolve({
            path: to.path
          });
          return _context.abrupt("return", window.open(routeData.href, "_blank"));
        case 1:
          next();
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
// router.beforeEach((to, from, next) => {
//     if (_hmt) {
//         if (to.path) {
//             _hmt.push(['_trackPageview', '/#' + to.fullPath]);
//         }
//     }
//     next();
// });

// router.afterEach((to, from, next) => {
//   window.scrollTo(0, 0)
// })

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
function resetRouter() {
  var newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}
var _default = exports.default = router;